// 监考
export default [
  // 考试首页
  {
    path: '/waitingExamination',
    name: 'waitingExamination',
    component: () =>
      import(/* webpackChunkName: "invigilate" */ '@/components/bloom-proctor/index')
  },
  // 设备调试
  {
    path: '/bloomEquipment',
    name: 'bloomEquipment',
    component: () =>
      import(/* webpackChunkName: "invigilate" */ '@/components/bloom-equipment/index')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/bloom-proctor.js